// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"fd7b8d25f2bc7e75","2013":"6da9e27a1cec7792","2048":"1612eb0684c3cad8","3492":"a5201c15ca7dacf0","3807":"0d3b5fa11e61b00b","7957":"67e48c4fd2e94e62"}[chunkId] + ".js";
};